export default {
  namespaced: true,
  state: {
    showSettings: false,
    showTriggerTabs: false
  },
  getters: {
    showSettings: (state) => {
      return state.showSettings;
    },
    showTriggerTabs: (state) => {
      return state.showTriggerTabs;
    }
  },
  mutations: {
    setShowSettings (state, show) {
      state.showSettings = show; // sets to either true or false
    },
    setShowTriggerTabs (state, show) {
      state.showTriggerTabs = show; // sets to either true or false
    }
  },
  actions: {
    toggleShowSettings ({commit}, show) {
      commit('setShowSettings', show);
    },
    toggleShowTriggerTabs ({commit}, show) {
      commit('setShowTriggerTabs', show);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/editorModule.js